module.exports = __webpack_public_path__ + "static/media/Road Patcher.0ccf0851.png";